import React from 'react';
export function TopBanner() {
  return <div className="bg-[#1A7B7E] text-white py-2 px-4 md:px-8" data-id="element-457">
      <div className="max-w-7xl mx-auto flex justify-center items-center text-xs md:text-sm font-bold tracking-wide" data-id="element-458">
        <div className="flex items-center gap-2 text-center" data-id="element-459">
          <span className="text-[#FFC107]" data-id="element-460">COMING SOON</span>
          <span data-id="element-461">SECURE CARAVAN, MOTORHOME & BOAT STORAGE IN PERTH'S NORTH</span>
        </div>
      </div>
    </div>;
}